/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Parq_3Inputs */

const en_us2_onboarding_parq_3 = /** @type {(inputs: Onboarding_Parq_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the last month, have you had chest pain while not doing physical activity?`)
};

const pt_br2_onboarding_parq_3 = /** @type {(inputs: Onboarding_Parq_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No último mês, você sentiu dor no peito sem estar fazendo atividade física?`)
};

const es_419_onboarding_parq_3 = /** @type {(inputs: Onboarding_Parq_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En el último mes, ¿has tenido dolor en el pecho sin estar haciendo actividad física?`)
};

const pt_pt2_onboarding_parq_3 = /** @type {(inputs: Onboarding_Parq_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No último mês, sentiste dor no peito sem estares a fazer atividade física?`)
};

const fr_fr2_onboarding_parq_3 = /** @type {(inputs: Onboarding_Parq_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au cours du dernier mois, as-tu ressenti une douleur à la poitrine en dehors de toute activité physique ?`)
};

const de_de2_onboarding_parq_3 = /** @type {(inputs: Onboarding_Parq_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hattest du im letzten Monat Schmerzen in der Brust, ohne dich körperlich zu betätigen?`)
};

const it_it2_onboarding_parq_3 = /** @type {(inputs: Onboarding_Parq_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nell'ultimo mese hai avuto dolore al petto mentre non facevi attività fisica?`)
};

/**
* | output |
* | --- |
* | "In the last month, have you had chest pain while not doing physical activity?" |
*
* @param {Onboarding_Parq_3Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_parq_3 = /** @type {((inputs?: Onboarding_Parq_3Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Parq_3Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_parq_3(inputs)
	if (locale === "es-419") return es_419_onboarding_parq_3(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_parq_3(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_parq_3(inputs)
	if (locale === "de-DE") return de_de2_onboarding_parq_3(inputs)
	if (locale === "it-IT") return it_it2_onboarding_parq_3(inputs)
	return en_us2_onboarding_parq_3(inputs)
});
export { onboarding_parq_3 as "onboarding.parq.3" }